import { Loading, useAreModulesReady } from "@sgi/af-shell-shared";
import AppWithRouter from "./AppWithRouter";

export default function App() {
  const isReady = useAreModulesReady();

  if (!isReady) {
    return <Loading />;
  }
  return <AppWithRouter />;
}
